"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSION_SNAPSHOT_MAX_OVERLAYS = exports.PERMISSION_SNAPSHOT_PARTITION_COUNT = exports.PERMISSION_SNAPSHOT_MAX_REQUEST_RESOURCES = void 0;
exports.permissionSnapshotPartitionIndex = permissionSnapshotPartitionIndex;
/** Most resources one permission snapshot request may name. */
exports.PERMISSION_SNAPSHOT_MAX_REQUEST_RESOURCES = 250;
/** Fixed number of partitions a workspace's grants are stored in. */
exports.PERMISSION_SNAPSHOT_PARTITION_COUNT = 64;
/** Most delta overlays a partition keeps before its base is replaced. */
exports.PERMISSION_SNAPSHOT_MAX_OVERLAYS = 8;
const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;
/**
 * Stable partition of a resource: FNV-1a (32 bit) over the UTF-16 code units
 * of `${resourceType}:${resourceId}`, modulo the partition count. Depends only
 * on the resource id, so moving a doc between folders keeps its partition.
 * Pure arithmetic, identical in the browser, Electron main and Node.
 */
function permissionSnapshotPartitionIndex(resourceType, resourceId) {
    const key = `${resourceType}:${resourceId}`;
    let hash = FNV_OFFSET_BASIS;
    for (let index = 0; index < key.length; index += 1) {
        hash ^= key.charCodeAt(index);
        hash = Math.imul(hash, FNV_PRIME) >>> 0;
    }
    return hash % exports.PERMISSION_SNAPSHOT_PARTITION_COUNT;
}
//# sourceMappingURL=partition-index.js.map